import { render, staticRenderFns } from "./course_detail.vue?vue&type=template&id=004adef2&scoped=true"
import script from "./course_detail.vue?vue&type=script&lang=js"
export * from "./course_detail.vue?vue&type=script&lang=js"
import style0 from "./course_detail.vue?vue&type=style&index=0&id=004adef2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004adef2",
  null
  
)

export default component.exports